module.exports = __webpack_public_path__ + "img/P38-en.ee59d272.png";